import { defineMessages } from "react-intl";

const messages = defineMessages({
    title1: {
        id: "intro.rhytname.1.title",
    },
    title2: {
        id: "intro.rhytname.3.title",
    },
    title3: {
        id: "intro.rhytname.4.title",
    },
    description1: {
        id: "intro.rhytknock.1.description",
    },
    description2: {
        id: "intro.rhytknock.2.description",
    },
    description3: {
        id: "intro.rhytknock.3.description",
    },
});

export default messages;
